import React, { useState } from "react";
import PropTypes from "prop-types";
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";
import CircularProgress from "@mui/material/CircularProgress";
import useApi from "components/Utils/api";
import toast from "react-hot-toast";

function StatusToggleButton({ type, id, currentStatus, onSuccess }) {
  const [isLoading, setIsLoading] = useState(false);
  const api = useApi();

  const handleToggle = async () => {
    setIsLoading(true);
    const newStatus = currentStatus === 1 ? 0 : 1;
    const endpoint = type === 'vle' ? `vle/${id}/status` : `devices/${id}/status`;

    try {
      const response = await api.patch(endpoint, null, {
        params: { status: newStatus }
      });
      
      if (response.data.message) {
        toast.success(response.data.message);
        if (onSuccess) {
          onSuccess(response.data.data);
        }
      }
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.response?.data?.message || `Failed to update ${type} status`;
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <MDButton
      variant="text"
      color={currentStatus === 1 ? "success" : "error"}
      onClick={handleToggle}
      disabled={isLoading}
      startIcon={
        isLoading ? (
          <CircularProgress size={20} color="inherit" />
        ) : (
          <Icon>{currentStatus === 1 ? "toggle_on" : "toggle_off"}</Icon>
        )
      }
    >
      {currentStatus === 1 ? "Active" : "Inactive"}
    </MDButton>
  );
}

StatusToggleButton.propTypes = {
  type: PropTypes.oneOf(['vle', 'device']).isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  currentStatus: PropTypes.number.isRequired,
  onSuccess: PropTypes.func,
};

export default StatusToggleButton; 